const SpiderchartSVG = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%" /* fits the width of the SVG to the container */
      height="100%" /* fits the height of the SVG to the container */
      viewBox="0 0 200 200" /* sets the coordinate system */
      className="bg-neutralLight rounded-[50%]">
      {/* <!-- background Circles --> */}
      <circle
        cx="100"
        cy="100"
        r="80"
        fill="none"
        stroke="red"
        className="stroke-neutralDark"
        stroke-width="3"
      />
      <circle
        cx="100"
        cy="100"
        r="50"
        fill="none"
        className="stroke-neutralDark"
        stroke-width="3"
      />
      <circle
        cx="100"
        cy="100"
        r="20"
        fill="none"
        className="stroke-neutralDark"
        stroke-width="3"
      />

      {/* <!-- achses --> */}
      <line
        x1="100"
        y1="20"
        x2="100"
        y2="180"
        stroke-width="2"
        className="stroke-neutralDark"
      />
      <line
        x1="20"
        y1="100"
        x2="180"
        y2="100"
        className="stroke-neutralDark"
        stroke-width="2"
      />

      {/* <!--first fill --> */}
      <polygon
        points="100,40 120,80 140,100 110,140 90,120"
        className="fill-neutralDark"
      />

      {/* <!-- second fill --> */}
      <polygon
        points="100,30 130,70 160,100 130,130 100,160 80,140"
        className="fill-neutralDark/60"
      />

      {/* <!-- third fill --> */}
      <polygon
        points="100,20 150,70 180,100 150,150 100,180 50,140 60,70"
        className="fill-neutralDark/35"
      />
    </svg>
  );
};

export default SpiderchartSVG;
